// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d2f9de26","977":"11b6048f"}[chunkId] + ".chunk.js";
};